import React, { FunctionComponent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { QuestionMark } from './svgs/QuestionMark';
import { Tooltip, TooltipParagraph } from './Tooltip';

interface EligibilityCheckHelpProps {
  dataTestID: string;
}

export const EligibilityCheckHelp: FunctionComponent<EligibilityCheckHelpProps> =
  ({ dataTestID }) => {
    const intl = useIntl();

    return (
      <Tooltip
        id="eligibility-check-help"
        tip={
          <TooltipParagraph>
            <FormattedMessage
              defaultMessage="We use a <strong>soft credit pull</strong> to check your eligibility, so your credit score doesn't change"
              description="Eligibility check help tooltip text"
              values={{
                strong: (chunks: React.ReactNode) => (
                  <strong className="font-bold">{chunks}</strong>
                ),
              }}
            />
          </TooltipParagraph>
        }
        triggerClassName="inline-block px-1 align-middle"
        dataTestID={dataTestID}
        name={intl.formatMessage({
          defaultMessage: 'eligibility check help',
          description: 'eligibility check help description',
        })}
      >
        <QuestionMark
          aria-hidden="true"
          className="w-4 h-4 text-theme-primary"
        />
      </Tooltip>
    );
  };
